import { assign } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

const DropdownCaret = ({ style }) => {
    return (
        <i
            className="fa-solid fa-caret-down"
            size="lg"
            style={assign(
                {},
                {
                    color: '#FFF',
                    paddingLeft: '6px',
                    paddingRight: '6px',
                    paddingBottom: '4.5px',
                    overflowY: 'hidden',
                    fontSize: '16px',
                },
                style
            )}
        />
    );
};

DropdownCaret.propTypes = {
    style: PropTypes.object,
};

export default DropdownCaret;
